import { createSlice } from '@reduxjs/toolkit';

export const UsersPermissionsSlice = createSlice({
  name: 'usersPermissions',
  initialState: {
    users_permissions_list: [],
    user_with_permissions: {},
    userPemissionsAssigned: [],
  },
  reducers: {
    setUsersPemissionsRedux: (state, { payload }) => {
      state.users_permissions_list = payload;
    },
    setUserPemissionsRedux: (state, { payload }) => {
      state.user_with_permissions = payload;
    },
    setUserPemissionsAssignedRedux: (state, { payload }) => {
      state.userPemissionsAssigned = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUsersPemissionsRedux, setUserPemissionsRedux, setUserPemissionsAssignedRedux } =
  UsersPermissionsSlice.actions;
